var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 40,
    width: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m26 21.792-1.583-1.584q.708-2.541-1.209-4.312-1.916-1.771-4.25-1.146l-1.583-1.583q.542-.292 1.208-.438.667-.146 1.417-.146 2.75 0 4.667 1.917 1.916 1.917 1.916 4.667 0 .75-.145 1.437-.146.688-.438 1.188Zm5.292 5.25-1.459-1.375q1.792-1.375 3.167-3.021 1.375-1.646 2.167-3.479-2.084-4.417-6.105-7-4.02-2.584-8.854-2.584-1.458 0-2.958.25-1.5.25-2.583.667l-1.625-1.667q1.458-.583 3.333-.958 1.875-.375 3.75-.375 5.667 0 10.396 3.188 4.729 3.187 6.896 8.479-.959 2.333-2.5 4.312-1.542 1.979-3.625 3.563Zm2.125 9.25-6.75-6.667q-1.292.542-3.021.875-1.729.333-3.646.333-5.792 0-10.5-3.187-4.708-3.188-6.917-8.479.875-2.209 2.417-4.188Q6.542 13 8.5 11.417L3.542 6.458l1.5-1.5 29.791 29.834ZM9.958 12.875Q8.458 13.958 7 15.688q-1.458 1.729-2.208 3.479 2.125 4.416 6.208 7 4.083 2.583 9.167 2.583 1.416 0 2.791-.229T25.042 28l-2.667-2.708q-.417.208-1.104.333-.688.125-1.271.125-2.75 0-4.667-1.896-1.916-1.896-1.916-4.687 0-.584.125-1.229.125-.646.333-1.146Zm12.334 5.375ZM17.5 20.667Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonFilter);
export default __webpack_public_path__ + "static/media/button-filter.639f536a4102750a42ed9ae4c0089277.svg";
export { ForwardRef as ReactComponent };